import { render, staticRenderFns } from "./AdminBuildingStockList.vue?vue&type=template&id=40c07fa2&"
import script from "./AdminBuildingStockList.vue?vue&type=script&lang=js&"
export * from "./AdminBuildingStockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports